import { slotList } from "@/Util/manifest";

export default {
  PageBlockHomeIntro: {
    pageBlockTitle: "Home Intro",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: "video", priority: 0,
            label: "Video",
            type: 'relUuid',
            dbfield: { target: "File" }
          },
          {
            id: "aboveTitle", priority: 0,
            cols: 6,
            label: "Above title",
          },
          {
            id: "title", priority: 0,
            cols: 6,
            label: "Title",
          },
          {
            id: "intro", priority: 0,
            cols: 12,
            type: "text"
          },
          {
            id: "button1label", priority: 0,
            cols: 3,
            label: "Button 1 Label",
          },
          {
            id: "button1link", priority: 0,
            cols: 3,
            label: "Button 1 Link",
          },
          {
            id: "button2label", priority: 0,
            cols: 3,
            label: "Button 2 Label",
          },
          {
            id: "button2link", priority: 0,
            cols: 3,
            label: "Button 2 Link",
          },
        ]),
      },
    ]),
  },
  PageBlockHomeFeatures: {
    pageBlockTitle: "Home Features",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'cards', priority: 0,
            type: 'relMany',
            label: "Features",
            dbfield: {
              target: 'HomeFeature',
              cascade: "delete",
            },
          },
        ]),
      }
    ]),
  },
  HomeFeature: {
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'title', priority: 0,
            label: "Naslov",
            cols: 6,
            type: 'varchar',
          },
          {
            id: 'icon', priority: 0,
            label: "Icon",
            cols: 6,
            type: 'relUuid',
            dbfield: {
              target: "File",
            }
          },
          {
            id: 'intro', priority: 0,
            label: "Tekst",
            type: 'wysiwyg',
          },
        ]),
      },
    ]),
  },
  PageBlockHomeServices: {
    pageBlockTitle: "Home Services",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'cards', priority: 0,
            type: 'relMany',
            dbfield: {
              target: 'HomeService',
              cascade: "delete",
            },
          },
        ]),
      },
    ])
  },
  HomeService: {
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'title', priority: 0,
            label: "Naslov",
            cols: 6,
            type: 'varchar',
          },
          {
            id: 'photo', priority: 0,
            label: "Photo",
            cols: 6,
            type: 'relUuid',
            dbfield: {
              target: "File",
            }
          },
          {
            id: 'intro', priority: 0,
            label: "Tekst",
            type: 'wysiwyg',
          },
        ]),
      },
    ]),
  },
  PageBlockAbout: {
    pageBlockTitle: "About us",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'title', priority: 0,
            label: "Naslov",
            cols: 6,
            type: 'varchar',
          },
          {
            id: 'photo', priority: 0,
            label: "Photo",
            cols: 6,
            type: 'relUuid',
            dbfield: {
              target: "File",
            }
          },
          // {
          //   id: "blockGroup", priority: 0,
          //   label: "Content",
          //   labelClass: "label-block label-rel",
          //   cols: 12,
          // },
        ]),
      },
    ]),
  },
  PageBlockPartners: {
    pageBlockTitle: "Partners",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'title', priority: 0,
            label: "Naslov",
            cols: 6,
            type: 'varchar',
          },
        ]),
      },
    ]),
  },
  PageBlockContact: {
    pageBlockTitle: "Contact",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: 'title', priority: 0,
            label: "Naslov",
            type: "varchar",
            cols: 6,
          },
          {
            id: 'email', priority: 0,
            label: "Email",
            type: "varchar",
            cols: 6,
          },
          {
            id: 'desc', priority: 0,
            label: "Opis",
            type: "wysiwyg",
          },
        ]),
      }
    ]),
  },
}
